import ngDeps from "../ng-react-directives/ngr-injector";

export const navigateTo = (route) => {
  const { $state } = ngDeps;
  $state.go(route);
};

export const removeURLSearchParam = (
  searchParams: URLSearchParams,
  paramName: string
) => {
  const newSearchParams = new URLSearchParams(searchParams);
  newSearchParams.delete(paramName);
  return newSearchParams;
};
